import {ActivatedRoute} from '@angular/router';
import {BehaviorSubject} from 'rxjs';

export interface BreadcrumbItem {
    label: string;
    link: string;
}

export class BreadcrumbService {
    breadcrumbs$ = new BehaviorSubject<BreadcrumbItem[]>([]);

    constructor() {}

    public initBreadcrumbs(route: ActivatedRoute) {
        const breadcrumbs = this.createBreadcrumbs(route);
        this.breadcrumbs$.next(breadcrumbs);
    }

    private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: BreadcrumbItem[] = []): BreadcrumbItem[] {
        const children: ActivatedRoute[] = route.children;

        if (children.length === 0) {
            return breadcrumbs;
        }

        for (const child of children) {
            const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
            if (routeURL !== '') {
                url += `/${routeURL}`;
            }

            const data = child.snapshot.routeConfig?.data;
            if (data && data.breadcrumb) {
                breadcrumbs.push(
                    typeof data.breadcrumb === 'function'
                        ? {
                              label: data.breadcrumb(child.snapshot.data).label,
                              link: data.breadcrumb(child.snapshot.data).link,
                          }
                        : {
                              label: data.breadcrumb,
                              link: url,
                          }
                );
            }

            return this.createBreadcrumbs(child, url, breadcrumbs);
        }
    }
}
